import React, {Component} from 'react';
import styled, {withTheme} from 'styled-components';
import Glyph from './Glyph';


const SVG = styled.svg`
  width: 100%;
  height: auto;
`

class SvgFile extends Component {

  renderObjects(left, top){
    return this.props.objects.map( object => (
      <Glyph
        key={object.id}
        path={object.path}
        size={object.size}
        pos={{
          x: object.position.x - left,
          y: object.position.y - top,
        }}
      />
    ));
  }

  getBorders(){
    let borders = {
      left: 0,
      top:0,
      right: 0,
      bottom: 0
    };

    this.props.objects.forEach((obj,i) => {
      let {x, y} = obj.position;
      let {width, height} = obj.size;

      if(i === 0){
        borders.left = x;
        borders.top = y;
        borders.right = x + width;
        borders.bottom = y + height;
      }
      else{
        borders.left > x && ( borders.left = x );
        borders.top > y && ( borders.top = y );
        borders.right < x + width && ( borders.right = x + width );
        borders.bottom < y + height && ( borders.bottom = y + height );
      }
    });

    return borders;
  }

  render(){
    let { theme } = this.props;
    let { left, top, right, bottom } = this.getBorders();
    let width = right-left;
    let height = bottom-top;
    return (
      <SVG id="svgfile" width={width} height={height} xmlns="http://www.w3.org/2000/svg"  viewBox={`0 0 ${right-left} ${bottom-top}`}>
        <rect width={width} height={height} fill={theme.bg}/>
        {this.renderObjects(left,top)}
      </SVG>
    )
  }
}

export default withTheme(SvgFile);